import { render, staticRenderFns } from "./VirtualFibreNetworkOperators.vue?vue&type=template&id=1283be48&"
import script from "./VirtualFibreNetworkOperators.vue?vue&type=script&lang=js&"
export * from "./VirtualFibreNetworkOperators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports